/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalLogout } from './PortalLogout';
import {
    PortalLogoutFromJSON,
    PortalLogoutFromJSONTyped,
    PortalLogoutToJSON,
    PortalLogoutToJSONTyped,
} from './PortalLogout';

/**
 * 
 * @export
 * @interface PortalLogoutResponse
 */
export interface PortalLogoutResponse {
    /**
     * 
     */
    data: PortalLogout;
}

/**
 * Check if a given object implements the PortalLogoutResponse interface.
 */
export function instanceOfPortalLogoutResponse(value: object): value is PortalLogoutResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    return true;
}

export function PortalLogoutResponseFromJSON(json: any): PortalLogoutResponse {
    return PortalLogoutResponseFromJSONTyped(json, false);
}

export function PortalLogoutResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalLogoutResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': PortalLogoutFromJSON(json['data']),
    };
}

export function PortalLogoutResponseToJSON(json: any): PortalLogoutResponse {
    return PortalLogoutResponseToJSONTyped(json, false);
}

export function PortalLogoutResponseToJSONTyped(value?: PortalLogoutResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': PortalLogoutToJSON(value['data']),
    };
}

